import { UseFormReturn } from 'react-hook-form';

import { InputSchedulesWithDelivery } from '@/components/FormFields/InputSchedulesWithDelivery';

import { TProgramForm } from '../../types';

type TProgramScheduleListDrawerProps = {
  form: UseFormReturn<TProgramForm, unknown, undefined>;
};

export function ProgramScheduleListDrawer({ form }: TProgramScheduleListDrawerProps) {
  return (
    <div className="flex flex-1 flex-col gap-4">
      <InputSchedulesWithDelivery form={form} name="schedule" isOptionalEndHour />
    </div>
  );
}
